/* eslint-disable no-undef */
// 获取接口域名版本

let httpClient = null
let API_VERSION = null
let API_VERSION_H = null

export const http = () => {
  if (!httpClient) {
    raise(new Error('httpClient not defined'))
  }
  return httpClient
}

export const setHttpClient = (h) => {
  httpClient = h
}

export const setApiVersion = (av) => {
  API_VERSION = av
}

export const setApiVersionH = (av) => {
  API_VERSION_H = av
}

export const getApiVersion = () => {
  return API_VERSION
}

export const getApiVersionDygc = () => {
  return API_VERSION_H
}

export const getApiVersionH = () => {
  return API_VERSION_H
}